import { ChangeEvent, ReactNode } from 'react'
import { IconSearch } from '@tabler/icons-react'
import { cn } from '@/lib/utils'
import { Input } from './input'

interface SearchBoxProps {
  containerClass?: string
  placeHolder?: string
  onValueChange: (value: string) => void
  onFocus?: () => void
  onBlur?: () => void
  selectedItems?: ReactNode
  value?: string
}

const SearchBox = ({
  containerClass,
  onValueChange,
  placeHolder = 'Search',
  onFocus,
  onBlur,
  selectedItems,
  value,
}: SearchBoxProps) => {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-1.5 rounded-[8px] border border-[#D0D5DD] bg-white px-2',
        containerClass,
        !!selectedItems && 'py-1'
      )}
    >
      {selectedItems && (
        <div className='flex max-h-[100px] w-full flex-wrap gap-1.5 overflow-auto'>
          {selectedItems}
        </div>
      )}
      <IconSearch className='max-h-5 max-w-5 flex-shrink-0 text-[#667085]' />
      <Input
        className='min-w-[120px] flex-1 border-none text-base shadow-none outline-none'
        placeholder={placeHolder}
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onValueChange(e.target.value)
        }
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  )
}

export default SearchBox
